<template>
  <a-modal
    :width="modalWidth"
    :style="modalStyle"
    :visible="visible"
    :maskClosable="false"
    @cancel="handleCancel">
    <template slot="footer">
      <a-button @click="handleCancel">{{$t('button.close')}}</a-button>
    </template>
    <a-table
      ref="table"
      rowKey="id"
      size="middle"
      :columns="columns"
      :loading="loading"
      :dataSource="dataSource"
      :pagination="false">
      <template v-for="(item, index) in columns" :slot="item.slotName">
          <span :key="index">{{ $t(item.slotName) }}</span>
        </template>

        <template :slot="item.dataIndex" slot-scope="text, record" v-for="item in columns">
          <mtc-lang-list-popover :key="item.dataIndex" :record="record" :item="item" :text="text" />
        </template>

      <span slot="action" slot-scope="text, record">
        <a @click="handleBack(record.id)"><a-icon type="redo"/>{{$t('label.dictionaryFetch')}}</a>
        <a-divider type="vertical"/>
        <a @click="handleDelete(record.id)"><a-icon type="scissor"/>{{$t('button.deleteCompletely')}}</a>
      </span>
    </a-table>

  </a-modal>


</template>

<script>
  import { getAction,deleteAction,putAction } from '@/api/manage'
  export default {
    name: "DictDeleteList",
    data () {
      return {
        modalWidth: '90%',
        modalStyle: { 'top': '20px'},
        title: '操作',
        visible: false,
        loading: false,
        dataSource:[],
        columns:[
          {
            title: '#',
            dataIndex: '',
            key: 'rowIndex',
            width: 120,
            align: "center",
            customRender: function (t, r, index) {
              return parseInt(index) + 1;
            }
          },
          {
            slotName: 'tableHeader.dictionaryName',
            // title: '字典名称',
            align: "left",
            dataIndex: 'dictName',
            scopedSlots: { title: 'tableHeader.dictionaryName'}
          },
          {
            slotName: 'tableHeader.dictionaryNumber',
            // title: '字典编号',
            align: "left",
            dataIndex: 'dictCode',
            scopedSlots: { title: 'tableHeader.dictionaryNumber'}
          },
          {
            slotName: 'tableHeader.description',
            // title: '描述',
            align: "left",
            dataIndex: 'description',
            scopedSlots: { title: 'tableHeader.description'}
          },
          {
            slotName: 'tableHeader.operation',
            // title: '操作',
            dataIndex: 'action',
            align: "center",
            scopedSlots: {customRender: 'action', title: 'tableHeader.operation'}
          }
        ]
      }
    },

    methods: {
      handleCancel(){
        this.visible = false
        //回收站字典列表刷新
        this.$emit("refresh")
      },
      show(){
        this.visible = true
        this.loadData();
      },
      loadData(){
        this.loading = true
        getAction("/sys/dict/deleteList").then(res=>{
          this.loading = false
          if(res.success){
            this.dataSource = res.result
          }else{
            this.$message.warning(res.message)
          }
        })
      },
      handleBack(id){
        putAction("/sys/dict/back/"+id).then(res=>{
          if(res.success){
            this.$message.success(res.message)
            this.loadData();
          }else{
            this.$message.warning(res.message)
          }
        })
      },
      handleDelete(id){
        let this_ = this
        this.$confirm({
          title: this_.$t('label.deleteDictionaryCompletely'),
          content: (<div>
            <p>{this_.$t('label.areYouSureDeleteDictionaryCompletely')}</p>
            <p style="color:red;">{this_.$t('label.notePleaseBeCarefulItCannotBeRecoveredAfterDeletion')}</p>
            </div>),
          centered: false,
          onOk: () => {
          var that = this;
          deleteAction("/sys/dict/deletePhysic/"+id).then((res) => {
            if (res.success) {
              this.$message.success(res.message)
              this.loadData();
            } else {
              that.$message.warning(res.message);
            }
          });
        },
      })
      }

    }
  }
</script>

<style scoped>

</style>